import {InfoUser, ListUser, LogoutUser} from "@/api/user";
import {removeToken} from "@/api/cookie";

const state = () => ({
  users: [],
  currentUser: {},
})

// getters
const getters = {}

// actions
const actions = {
  async fetchUsers( { commit, dispatch }, params) {
    await dispatch("loading/setLoading", true, {root: true})
    ListUser(params).then((data) => {
      commit('setUsers', data.data.data)
    }).catch((err) => {
      console.log(err)
    }).finally(async () =>{
      await dispatch("loading/setLoading", false, {root: true})
    })
  },
  async fetchCurrentUser( { commit } ) {
    const response = await InfoUser()
    const user = response?.data?.data
    if (!user) {
      throw new Error('获取当前用户信息失败')
    }
    commit('setCurrentUser', user)
    return user
  },

  async logout({ commit }) {
    try {
      await LogoutUser()
    } catch (err) {
      console.log('注销失败：', err)
    } finally {
      removeToken()
      commit('setCurrentUser', {})
    }
    return true
  }

}



// mutations
const mutations = {
  setUsers(state, users) {
    console.log(users)
    state.users = users
  },
  setCurrentUser(state, user) {
    state.currentUser = user
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
